import { Axios } from "@/plugins";

export default {
  getUser: (params) => {
    const { email } = params;
    return Axios.get(`/user`);
  },
  editUser: (data) => {
    const  email  = data.email;
    return Axios.put(`/users/${email}`, {

        lastName: data.data.lastName,
        firstName: data.data.firstName,
        email:data.data.email,
        active:1,
        password:data.data.currentPassword,
        company:data.data.companyName,
        address:"",
        address2:"",
        district:"",
        city:"",
        postalCode:44000,
        country:"",
        role:"General Contractor"

    });
  },

  createCompany: (payload) => {
    return Axios.post("/user/dealer", {
        ...payload
    });
  },
  inviteDealer: (payload) => {
    return Axios.post("/user/dealer_contact", {
        ...payload
    });
  },
  getCompanies: () => {
    return Axios.get(`/user/dealer`);
  },
};

